// 按"用户可见字符"（grapheme）逐个迭代字符串。
// 优先使用 Intl.Segmenter 的 grapheme 粒度，运行时不支持时回退到按 code point 迭代。
function* iterateGraphemes(value: string): Generator<string> {
  const SegmenterCtor = globalThis.Intl?.Segmenter;
  if (typeof SegmenterCtor === "function") {
    const segmenter = new SegmenterCtor(undefined, { granularity: "grapheme" });
    for (const { segment } of segmenter.segment(value)) {
      yield segment;
    }
    return;
  }
  for (const ch of value) {
    yield ch;
  }
}

// 按"用户可见字符"安全截断字符串，避免把 emoji、代理对或组合字符切坏。
export function truncateUnicodeText(value: string, maxLength: number): string {
  if (!value || maxLength <= 0) return "";
  if (value.length <= maxLength) return value;

  let result = "";
  let count = 0;
  for (const seg of iterateGraphemes(value)) {
    if (count >= maxLength) break;
    result += seg;
    count++;
  }
  return result;
}

// 按"用户可见字符"统计字符串长度，与 truncateUnicodeText 同语义。
// 空串返回 0；ZWJ emoji、组合字符等复合字符算 1（无 Intl.Segmenter 时回退到 code point 计数）。
export function getUnicodeLength(value: string): number {
  if (!value) return 0;
  let count = 0;
  for (const _ of iterateGraphemes(value)) count++;
  return count;
}
